/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Lead_SourceInputs */

const en_clients_field_lead_source = /** @type {(inputs: Clients_Field_Lead_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How they found Recobra`)
};

const pt_br2_clients_field_lead_source = /** @type {(inputs: Clients_Field_Lead_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como descobriu a Recobra`)
};

/**
* | output |
* | --- |
* | "How they found Recobra" |
*
* @param {Clients_Field_Lead_SourceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_lead_source = /** @type {((inputs?: Clients_Field_Lead_SourceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Lead_SourceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_lead_source(inputs)
	return pt_br2_clients_field_lead_source(inputs)
});